var component = require('../../../lib/js/component.js');
var Form = require('../forms/form.js');
var constants = require('../forms/constants.js');
var analyticsForm = require('../forms/analyticsForm');
var AdobeLaunch = require('../../../lib/js/adobelaunch.js');

function LandInquiryForm() {
    var self = this;
    var $landInquiryFormEl, $messageEl, $thankYouUserEl, $thankYouBrandEl, $submitButton, top;

    this.initialize = function (options, element) {
        $landInquiryFormEl = this.$element.find('form');
        top = $landInquiryFormEl.scrollTop();

        $landInquiryFormEl
            .detach( Form )
            .attach( Form )
            .on( constants.FORM_AJAX_SUBMIT, this.handleFormSubmission.bind(this) );

        
        $messageEl = this.$element.find(".LandInquiryForm__Thank-you");
        $thankYouUserEl = this.$element.find(".LandInquiryForm__Thank-you-user");
        $thankYouBrandEl = this.$element.find(".LandInquiryForm__Thank-you-brand");
        $submitButton = this.$element.find(".LandInquiryForm__Submit-button"); 
    }
    
    this.handleFormSubmission = function (event, form) {
        event.preventDefault();
        var moduleName = "Land Inquiry Form";

        $.ajax({
            method: form.options.method,
            url: form.options.action,
            data: form.data,
            dataType: "json",
            context: this,
            success: function (response) {
                if (response.success) {
                    self.onLandInquiryFormSubmissionSuccess(form.data);
                    analyticsForm.RewriteObjectForm(response, event);
                    $submitButton.prop('disabled', false);
                }
            },
            error: self.onError
        });
    }

  this.onLandInquiryFormSubmissionSuccess = function (formData) {
    if ($landInquiryFormEl && $messageEl && $thankYouUserEl && $thankYouBrandEl) {
        $thankYouUserEl.text(formData.FirstName);
        $thankYouBrandEl.text(formData.BrandName);
      
        // hide landInquiryForm, show message div.
      $landInquiryFormEl.hide();
      $messageEl.show();
      var scrollDest = top - $messageEl.height();
      scrollDest = scrollDest < 0 ? 0 : scrollDest;
        $("html, body").animate({ scrollTop: scrollDest }, 100);
    }
  }
}

module.exports = component(LandInquiryForm);